import { Package } from '@features/DynamicPackagesConfigurationWizard/types';
import { isDynamicPackage } from './isDynamicPackage';

export const hasPackageToCheck = (packageData?: Package | null) =>
  isDynamicPackage(packageData) || packageData?.meta?.entityType === 'SpaPackage';
